var map = {
	"./apparel/8sian blue.webp": 19205,
	"./apparel/8sian dress.webp": 82519,
	"./apparel/8sian mie shirt.webp": 2636,
	"./apparel/8sian.webp": 78988,
	"./apparel/adat.webp": 38382,
	"./apparel/afghan dress.webp": 8058,
	"./apparel/aodai.webp": 77909,
	"./apparel/asian waitress.webp": 67019,
	"./apparel/asparas.webp": 69391,
	"./apparel/barotsaya.webp": 47694,
	"./apparel/bathrobe red.webp": 57745,
	"./apparel/bathrobe.webp": 44340,
	"./apparel/batik.webp": 16847,
	"./apparel/bear suit.webp": 13601,
	"./apparel/bidayuh.webp": 59660,
	"./apparel/blue shirt.webp": 11713,
	"./apparel/cheongsam blue.webp": 76887,
	"./apparel/cheongsam.webp": 59042,
	"./apparel/dewi lanjar.webp": 31670,
	"./apparel/empress.webp": 26668,
	"./apparel/fairy blue.webp": 87160,
	"./apparel/fairy white.webp": 22152,
	"./apparel/garuda.webp": 65633,
	"./apparel/gurung.webp": 16293,
	"./apparel/hanbok.webp": 56302,
	"./apparel/hanfu.webp": 72932,
	"./apparel/harajuku.webp": 44260,
	"./apparel/inari.webp": 19246,
	"./apparel/iron fan.webp": 51386,
	"./apparel/kali.webp": 49772,
	"./apparel/karate.webp": 72006,
	"./apparel/khutulun.webp": 91753,
	"./apparel/kill bill.webp": 54268,
	"./apparel/kimono.webp": 2001,
	"./apparel/mahjong.webp": 74847,
	"./apparel/military.webp": 91214,
	"./apparel/modern kimono.webp": 42942,
	"./apparel/moga.webp": 81951,
	"./apparel/muay thai.webp": 64451,
	"./apparel/nangkwak.webp": 12705,
	"./apparel/nezha.webp": 81468,
	"./apparel/ninja.webp": 41081,
	"./apparel/nuwa.webp": 37315,
	"./apparel/nyonya.webp": 15574,
	"./apparel/pink bikini.webp": 25203,
	"./apparel/pink shirt.webp": 35926,
	"./apparel/pink top.webp": 9134,
	"./apparel/puteri gunung ledang.webp": 9832,
	"./apparel/rouge red.webp": 68269,
	"./apparel/sailor fighter.webp": 66541,
	"./apparel/sailor shirt.webp": 59169,
	"./apparel/sari red.webp": 33007,
	"./apparel/sari.webp": 1674,
	"./apparel/sarong.webp": 46786,
	"./apparel/shalwarkameez.webp": 25369,
	"./apparel/sporty Top.webp": 88668,
	"./apparel/srilanka.webp": 61668,
	"./apparel/suit black.webp": 2139,
	"./apparel/suit white.webp": 99865,
	"./apparel/tengu.webp": 86707,
	"./apparel/terno.webp": 73030,
	"./apparel/thai.webp": 43863,
	"./apparel/tube.webp": 32106,
	"./apparel/turtle neck.webp": 59083,
	"./apparel/vagabond.webp": 83977,
	"./apparel/video game girl blue.webp": 82148,
	"./apparel/video game girl white.webp": 70797,
	"./apparel/wuxia.webp": 64653,
	"./apparel/yukionna.webp": 90037,
	"./background/amaterasu.webp": 82403,
	"./background/apsaras.webp": 27813,
	"./background/black.webp": 20930,
	"./background/blue pattern.webp": 356,
	"./background/blue.webp": 54917,
	"./background/chang er.webp": 72224,
	"./background/cute.webp": 56772,
	"./background/dark blue.webp": 91082,
	"./background/dark pink.webp": 90619,
	"./background/devil blue.webp": 42240,
	"./background/dewi lanjar.webp": 33740,
	"./background/empress.webp": 93994,
	"./background/fan pattern.webp": 84194,
	"./background/fuujin.webp": 94620,
	"./background/garuda.webp": 62971,
	"./background/green gradient.webp": 32895,
	"./background/green.webp": 2279,
	"./background/inari.webp": 64368,
	"./background/india.webp": 32849,
	"./background/iron fan.webp": 60802,
	"./background/japan.webp": 49662,
	"./background/korea.webp": 98441,
	"./background/lakshimi.webp": 82831,
	"./background/lotus.webp": 73444,
	"./background/milk.webp": 57599,
	"./background/mountain.webp": 65851,
	"./background/nangkwak.webp": 9020,
	"./background/nezha.webp": 24951,
	"./background/nuwa.webp": 66602,
	"./background/orange.webp": 47753,
	"./background/phramae.webp": 68366,
	"./background/pink pattern.webp": 46928,
	"./background/pink.webp": 27132,
	"./background/purple gradient.webp": 92684,
	"./background/puteri gunung ledang.webp": 7152,
	"./background/raijin.webp": 85904,
	"./background/red gradient.webp": 97395,
	"./background/red.webp": 53133,
	"./background/saraswati.webp": 83187,
	"./background/tengu.webp": 86086,
	"./background/thailand.webp": 65948,
	"./background/vietnam.webp": 44694,
	"./background/yellow gradient.webp": 15079,
	"./background/yellow.webp": 50489,
	"./background/yukionna.webp": 72636,
	"./earrings/abstract.webp": 57423,
	"./earrings/asparas.webp": 88591,
	"./earrings/big.webp": 66338,
	"./earrings/boat noodle.webp": 28765,
	"./earrings/chang er.webp": 71800,
	"./earrings/drop.webp": 76874,
	"./earrings/empress.webp": 34970,
	"./earrings/fan.webp": 94017,
	"./earrings/lakshimi.webp": 19898,
	"./earrings/loop.webp": 24825,
	"./earrings/none.webp": 54566,
	"./earrings/origami crane.webp": 7001,
	"./earrings/pearl.webp": 77154,
	"./earrings/puteri gunung ledang.webp": 25848,
	"./earrings/saraswati.webp": 14226,
	"./earrings/sushi.webp": 73988,
	"./earrings/tengu.webp": 68024,
	"./earrings/thai.webp": 59388,
	"./earrings/white flora.webp": 98716,
	"./eyes/almond sleepy.webp": 37467,
	"./eyes/almond.webp": 33953,
	"./eyes/amaterasu.webp": 84545,
	"./eyes/big catliner.webp": 98186,
	"./eyes/big eyes unimpressed.webp": 32899,
	"./eyes/big roll.webp": 40863,
	"./eyes/big sleepy.webp": 38825,
	"./eyes/big wink.webp": 86340,
	"./eyes/big.webp": 87938,
	"./eyes/blue.webp": 75729,
	"./eyes/double eyelids.webp": 6139,
	"./eyes/empress.webp": 37309,
	"./eyes/geisha.webp": 44948,
	"./eyes/inari.webp": 77266,
	"./eyes/kumiho.webp": 94833,
	"./eyes/light makeup.webp": 47871,
	"./eyes/nezha.webp": 27549,
	"./eyes/small eyes unimpressed.webp": 75080,
	"./eyes/small roll.webp": 80648,
	"./eyes/small sleepy.webp": 14204,
	"./eyes/small wink.webp": 24054,
	"./eyes/small.webp": 36210,
	"./eyes/youkai.webp": 94889,
	"./eyewear/black.webp": 72095,
	"./eyewear/bling.webp": 49963,
	"./eyewear/frameless.webp": 21148,
	"./eyewear/gold.webp": 34770,
	"./eyewear/none.webp": 29725,
	"./eyewear/red.webp": 33717,
	"./eyewear/sunglasses.webp": 74327,
	"./face filter/none.webp": 14440,
	"./face filter/sichuan.webp": 30935,
	"./face filter/sparkle face.webp": 21826,
	"./face filter/tanaka.webp": 75701,
	"./forehead accessory/bindi dot.webp": 93245,
	"./forehead accessory/bindi gold.webp": 29644,
	"./forehead accessory/bindi purple.webp": 76470,
	"./forehead accessory/bindi puteri gunung ledang.webp": 66407,
	"./forehead accessory/bindi red.webp": 37349,
	"./forehead accessory/chang er mark.webp": 68185,
	"./forehead accessory/empress mark.webp": 32596,
	"./forehead accessory/none.webp": 22901,
	"./forehead accessory/tang mark.webp": 88723,
	"./hairstyle/adat.webp": 97741,
	"./hairstyle/all back pony.webp": 36098,
	"./hairstyle/all back tied.webp": 67356,
	"./hairstyle/amaterasu.webp": 54353,
	"./hairstyle/asian bowl.webp": 57968,
	"./hairstyle/bear.webp": 4112,
	"./hairstyle/bidayuh.webp": 35368,
	"./hairstyle/big wave.webp": 55099,
	"./hairstyle/blue wavy.webp": 74639,
	"./hairstyle/boycut.webp": 77445,
	"./hairstyle/chang er.webp": 62462,
	"./hairstyle/checker hat.webp": 27355,
	"./hairstyle/devil blue.webp": 64385,
	"./hairstyle/devil red.webp": 99261,
	"./hairstyle/dewi lanjar.webp": 27831,
	"./hairstyle/double pony.webp": 63954,
	"./hairstyle/empress.webp": 14852,
	"./hairstyle/fairy black.webp": 58632,
	"./hairstyle/fairy white.webp": 36991,
	"./hairstyle/farmer hat.webp": 50991,
	"./hairstyle/geisha.webp": 88364,
	"./hairstyle/gel short.webp": 73148,
	"./hairstyle/graduation hat.webp": 9076,
	"./hairstyle/gurung dress.webp": 16351,
	"./hairstyle/harajuku.webp": 75612,
	"./hairstyle/helmet bike.webp": 70769,
	"./hairstyle/helmet pink.webp": 38021,
	"./hairstyle/highlight.webp": 61221,
	"./hairstyle/hijab.webp": 40444,
	"./hairstyle/hime.webp": 96319,
	"./hairstyle/iron fan.webp": 19084,
	"./hairstyle/jiangshi.webp": 22322,
	"./hairstyle/jingju.webp": 94501,
	"./hairstyle/korean.webp": 36506,
	"./hairstyle/lakshimi.webp": 59496,
	"./hairstyle/long.webp": 60341,
	"./hairstyle/maroon.webp": 67860,
	"./hairstyle/mask.webp": 62645,
	"./hairstyle/mecha.webp": 5019,
	"./hairstyle/mermaid blue.webp": 64161,
	"./hairstyle/mermaid red.webp": 447,
	"./hairstyle/military.webp": 37299,
	"./hairstyle/moga.webp": 75151,
	"./hairstyle/muay thai.webp": 38311,
	"./hairstyle/nangkwak.webp": 43295,
	"./hairstyle/nezha.webp": 90017,
	"./hairstyle/ninja.webp": 37995,
	"./hairstyle/nyonya.webp": 38688,
	"./hairstyle/phramae.webp": 42623,
	"./hairstyle/puteri gunung ledang.webp": 35708,
	"./hairstyle/rouge blue.webp": 44526,
	"./hairstyle/shaolin.webp": 36779,
	"./hairstyle/short.webp": 92857,
	"./hairstyle/straw hat.webp": 42810,
	"./hairstyle/thai.webp": 69385,
	"./hairstyle/traditional thai.webp": 64362,
	"./hairstyle/two buns.webp": 12851,
	"./hairstyle/wavy.webp": 66926,
	"./hairstyle/wuxia.webp": 39707,
	"./hairstyle/yukionna.webp": 78019,
	"./head accessory/airpod.webp": 14520,
	"./head accessory/cat ear headset.webp": 80909,
	"./head accessory/cat ear.webp": 65731,
	"./head accessory/halo.webp": 70154,
	"./head accessory/none.webp": 96057,
	"./head accessory/rabbit ear.webp": 1711,
	"./head accessory/rafflesia.webp": 13114,
	"./head accessory/sleep mask.webp": 89209,
	"./head accessory/sticker bubbletea.webp": 9068,
	"./head accessory/sticker manekineko.webp": 73016,
	"./head accessory/vaposcent.webp": 98945,
	"./lips/bubble gum.webp": 30774,
	"./lips/dumbfounded.webp": 8547,
	"./lips/facemask cat.webp": 26614,
	"./lips/facemask.webp": 69650,
	"./lips/geisha.webp": 19382,
	"./lips/kali.webp": 60423,
	"./lips/mermaid blue.webp": 68137,
	"./lips/mermaid red.webp": 12681,
	"./lips/none.webp": 3103,
	"./lips/pouty.webp": 11098,
	"./lips/red.webp": 75710,
	"./lips/small.webp": 407,
	"./lips/smile.webp": 92994,
	"./lips/thick lips smile.webp": 10424,
	"./lips/tongue out.webp": 37884,
	"./lips/tongue twist.webp": 31099,
	"./lips/unimpressed.webp": 68028,
	"./necklace/abstract.webp": 73147,
	"./necklace/adat.webp": 12933,
	"./necklace/airpod.webp": 85013,
	"./necklace/amaterasu.webp": 52583,
	"./necklace/bidayuh.webp": 19006,
	"./necklace/choker.webp": 89460,
	"./necklace/garuda.webp": 28282,
	"./necklace/gurung dress.webp": 49351,
	"./necklace/heart necklace.webp": 57859,
	"./necklace/indo.webp": 64568,
	"./necklace/mermaid.webp": 50518,
	"./necklace/nezha.webp": 89284,
	"./necklace/none.webp": 62505,
	"./necklace/pearl.webp": 98376,
	"./necklace/qing.webp": 86371,
	"./necklace/rapper.webp": 34452,
	"./necklace/saraswati.webp": 79373,
	"./necklace/simple.webp": 55544,
	"./necklace/thai.webp": 75988,
	"./necklace/white flora.webp": 13012,
	"./nose/big ring.webp": 59017,
	"./nose/big.webp": 99148,
	"./nose/high ring.webp": 94149,
	"./nose/high.webp": 60933,
	"./nose/round ring.webp": 34838,
	"./nose/round.webp": 99142,
	"./nose/small ring.webp": 22597,
	"./nose/small.webp": 61225,
	"./skin/beige.webp": 19711,
	"./skin/espresso.webp": 27005,
	"./skin/geisha.webp": 39890,
	"./skin/gold.webp": 97282,
	"./skin/hologram.webp": 93797,
	"./skin/latte.webp": 93471,
	"./skin/pale.webp": 89499,
	"./skin/yellow.webp": 24765,
	"./tattoo/calaveras.webp": 26548,
	"./tattoo/cyborg.webp": 42150,
	"./tattoo/dragon.webp": 35023,
	"./tattoo/fuujin.webp": 83722,
	"./tattoo/henna.webp": 32336,
	"./tattoo/iban.webp": 9763,
	"./tattoo/neck.webp": 33646,
	"./tattoo/none.webp": 96106,
	"./tattoo/raijin.webp": 38635,
	"./tattoo/skull.webp": 13203,
	"./tattoo/yakuza.webp": 25702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78135;